import * as AnnouncementActions from '../actions';
import { TAB_FILTER } from '../../constants';

const defaultFilter = {
  textSearch: '',
};

const initialState = {
  loading: false,
  activeTab: TAB_FILTER.ACTIVE,
  filter: defaultFilter,
  message: '',
};

const list = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case AnnouncementActions.CHANGE_ANNOUNCEMENT_TAB:
      return { ...state, activeTab: payload };
    case AnnouncementActions.SET_ANNOUNCEMENT_FILTER:
      return { ...state, filter: payload.filter };
    case AnnouncementActions.RESET_ANNOUNCEMENT_FILTER:
      return { ...state, filter: defaultFilter };
    case AnnouncementActions.DELETE_ANNOUNCEMENT:
    case AnnouncementActions.ACTIVATE_ANNOUNCEMENT:
    case AnnouncementActions.EXPIRE_ANNOUNCEMENT:
      return { ...state, loading: true };
    case AnnouncementActions.DELETE_ANNOUNCEMENT_SUCCESS:
    case AnnouncementActions.ACTIVATE_ANNOUNCEMENT_SUCCESS:
    case AnnouncementActions.EXPIRE_ANNOUNCEMENT_SUCCESS:
      return { ...state, loading: false };
    case AnnouncementActions.DELETE_ANNOUNCEMENT_FAIL:
    case AnnouncementActions.ACTIVATE_ANNOUNCEMENT_FAIL:
    case AnnouncementActions.EXPIRE_ANNOUNCEMENT_FAIL:
      return { ...state, loading: false, message: payload?.message };
    default:
      return state;
  }
};

export default list;
